// Mock pra demo de notificacao push (NotificacoesPedidoProvider).
// Substituido em producao por dados reais do backend.

export const PEDIDOS_PENDENTES_LOCADOR_MOCK = [
  {
    id: 'PED-2001',
    cliente: { nome: 'Maria Santos', nota: 4.8, locacoesAnteriores: 12, foto: '👩' },
    produto: { id: 1, nome: 'Betoneira 400L Profissional', img: '🏗️', preco: 85 },
    dias: 3,
    total: 255,
    caucao: 150,
    tipoEntrega: 'freteiro',
    endereco: 'Rua das Flores, 123 - Setor Sul, Goiânia',
    distancia: 4.5,
    criadoEm: new Date(Date.now() - 5 * 60 * 1000).toISOString(), // 5 min atrás
    status: 'aguardando_locador',
    modoAutomatico: false,
  },
  {
    id: 'PED-2002',
    cliente: { nome: 'João Silva', nota: 4.5, locacoesAnteriores: 3, foto: '👨' },
    produto: { id: 4, nome: 'Kit Sonorização 5000W', img: '🔊', preco: 380 },
    dias: 1,
    total: 380,
    caucao: 0,
    tipoEntrega: 'entrega',
    endereco: 'Av. T-9, 500 - Setor Bueno, Goiânia',
    distancia: 2.1,
    criadoEm: new Date(Date.now() - 12 * 60 * 1000).toISOString(), // 12 min atrás
    status: 'aguardando_locador',
    modoAutomatico: false,
  },
];
